import React, { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { initializeApp } from "firebase/app";
import AdminLogin from "./AdminLogin"; // ✅ Make sure this file exists
import Sidebar from "./components/Sidebar";
import Dashboard from "./components/Dashboard";
import Customers from "./components/Customers";
import Stores from "./components/Stores";
import Orders from "./components/Orders";
import Deals from "./components/Deals";
import SearchHistory from "./components/SearchHistory";
import Earnings from "./components/Earnings";

// ✅ Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyAtpO96gGrJ6PHYQPAa1XlVEp7kjMGeA6A",
  authDomain: "faststyle-f63a1.firebaseapp.com",
  projectId: "faststyle-f63a1",
  storageBucket: "faststyle-f63a1.appspot.com",
  messagingSenderId: "200647176505",
  appId: "1:200647176505:web:645def56921617af94f8e8",
  measurementId: "G-D4R7EKKQ0X"
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

function App() {
  const [activePage, setActivePage] = useState("Dashboard");
  const [isLoggedIn, setIsLoggedIn] = useState(false); // ✅ Login check
  const [checkingAuth, setCheckingAuth] = useState(true); // ✅ Avoid flicker

  // ✅ Check if admin is logged in
  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      setIsLoggedIn(!!user); // true if user exists
      setCheckingAuth(false); // Done checking
    });
  }, []);

  const renderPage = () => {
    switch (activePage) {
      case "Dashboard":
        return <Dashboard />;
      case "Customers":
        return <Customers />;
      case "Stores":
        return <Stores />;
      case "Orders":
        return <Orders />;
      case "Deals":
        return <Deals />;
      case "SearchHistory":
        return <SearchHistory />;
      case "Earnings":
        return <Earnings />;
      default:
        return <Dashboard />;
    }
  };

  if (checkingAuth) {
    return <p>Checking login...</p>; // ✅ While checking auth
  }

  if (!isLoggedIn) {
    return <AdminLogin />; // ✅ Not logged in, show login
  }

  return (
    <div style={{ display: "flex" }}>
      <Sidebar onSelect={setActivePage} />
      <div style={{ flex: 1, padding: "20px" }}>{renderPage()}</div>
    </div>
  );
}

export default App;
